import { render, staticRenderFns } from "./FirstHome.vue?vue&type=template&id=8f477142&scoped=true&"
import script from "./FirstHome.vue?vue&type=script&lang=js&"
export * from "./FirstHome.vue?vue&type=script&lang=js&"
import style0 from "./FirstHome.vue?vue&type=style&index=0&id=8f477142&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f477142",
  null
  
)

export default component.exports